// import React, { useState, useEffect, useRef } from "react";
// import toast from "react-hot-toast";
// import api, { getFreshAccessToken } from "../../../chat/api";
// import MemoizedMarkdown from "../MemoizedMarkdown"; // FIX: Updated to import default from the standalone file

// const SectionContentExpandedView = ({
//   section,
//   sectionContent,
//   onClose,
//   onSave,
//   folderId,
//   onRefreshAnalyze,
// }) => {
//   const processedContent =
//     typeof sectionContent === "string"
//       ? sectionContent
//       : JSON.stringify(sectionContent, null, 2);

//   const [editedContent, setEditedContent] = useState(processedContent || "");
//   const [originalContent, setOriginalContent] = useState(processedContent || "");
//   const [hasContentChanged, setHasContentChanged] = useState(false);
//   const [isSaving, setIsSaving] = useState(false);
//   const [saveSuccess, setSaveSuccess] = useState(false);
//   const contentRef = useRef(null);

//   // Force remount of contentEditable div to prevent React removeChild crash
//   const [prevResponse, setPrevResponse] = useState(processedContent);
//   const [renderKey, setRenderKey] = useState(0);

//   if (processedContent !== prevResponse) {
//     setPrevResponse(processedContent);
//     setRenderKey(renderKey + 1);
//     setEditedContent(processedContent || "");
//     setOriginalContent(processedContent || "");
//     setHasContentChanged(false);
//   }

//   // Handle the save button text display timeout
//   useEffect(() => {
//     if (saveSuccess) {
//       const timer = setTimeout(() => {
//         setSaveSuccess(false);
//         if (onSave) onSave();
//       }, 1000);
//       return () => clearTimeout(timer);
//     }
//   }, [saveSuccess, onSave]);

//   const handleContentChange = (e) => {
//     const newContent = e.currentTarget.textContent;
//     setEditedContent(newContent);
//     setHasContentChanged(newContent !== originalContent);
//   };

//   const handleSaveContent = async () => {
//     if (!hasContentChanged) return;

//     setIsSaving(true);
//     setSaveSuccess(false);

//     try {
//       const token = await getFreshAccessToken();

//       const response = await api.patch(
//         `api/v1/rfp/folders/${folderId}/analysis/edit/`,
//         {
//           section_id: section.id.toString(),
//           section_response: editedContent,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (response.status === 200 || response.status === 201) {
//         setOriginalContent(editedContent);
//         setHasContentChanged(false);

//         // Fetch fresh data before closing edit mode
//         if (onRefreshAnalyze) {
//           await onRefreshAnalyze();
//         }

//         setIsSaving(false);
//         setSaveSuccess(true);
//       } else {
//         throw new Error(`Failed to save: ${response.status}`);
//       }
//     } catch (error) {
//       console.error("Save error:", error);
//       setIsSaving(false);

//       let errorMessage = "Failed to save changes";
//       if (error.response?.data?.error) {
//         errorMessage = error.response.data.error;
//       } else if (error.response?.data?.message) {
//         errorMessage = error.response.data.message;
//       } else if (error.message) {
//         errorMessage = error.message;
//       }

//       toast.error(errorMessage);
//     }
//   };

//   const getSaveButtonText = () => {
//     if (isSaving) return "Saving...";
//     if (saveSuccess) return "Saved";
//     return "Save";
//   };

//   return (
//     <div className="bg-white border border-[#BB42AE] rounded-[8px] shadow-sm overflow-hidden flex flex-col">
//       {/* Editable Response Content */}
//       <div className="p-5 overflow-y-auto max-h-[calc(100vh-500px)] min-h-[150px] custom-scrollbar">
//         {processedContent ? (
//           <div
//             key={`editable-${renderKey}`}
//             ref={contentRef}
//             contentEditable={true}
//             suppressContentEditableWarning={true}
//             onInput={handleContentChange}
//             className="prose prose-sm max-w-none text-[#18101C] font-outfit leading-relaxed outline-none focus:outline-none text-[14px]"
//           >
//             <MemoizedMarkdown content={processedContent} />
//           </div>
//         ) : (
//           <div
//             key={`empty-${renderKey}`}
//             ref={contentRef}
//             contentEditable={true}
//             suppressContentEditableWarning={true}
//             onInput={handleContentChange}
//             className="text-gray-400 italic font-outfit text-[14px] outline-none focus:outline-none min-h-[100px] flex items-center justify-center"
//           >
//             No content generated yet.
//           </div>
//         )}
//       </div>

//       {/* Action Buttons */}
//       <div className="px-4 py-3 border-t border-gray-100 flex items-center justify-end gap-3 bg-white">
//         <button
//           onClick={onClose}
//           className="px-6 py-1.5 rounded-md bg-white border border-[#BB42AE] text-[#BB42AE] text-[14px] font-outfit font-medium hover:bg-[#FFECFD] transition-colors"
//         >
//           Cancel
//         </button>

//         <button
//           onClick={handleSaveContent}
//           disabled={!hasContentChanged || isSaving}
//           className={`px-6 py-1.5 rounded-md text-[14px] font-outfit font-medium transition-colors ${
//             saveSuccess
//               ? "bg-[#BB42AE] text-white"
//               : !hasContentChanged || isSaving
//               ? "bg-[#BB42AE] text-white opacity-60 cursor-not-allowed"
//               : "bg-[#BB42AE] text-white hover:opacity-90"
//           }`}
//         >
//           {getSaveButtonText()}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default SectionContentExpandedView;
import React, { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import api, { getFreshAccessToken } from "../../../chat/api";
import MemoizedMarkdown from "../MemoizedMarkdown"; // FIX: Updated to import default from the standalone file
import TurndownService from "turndown";
import { gfm } from "turndown-plugin-gfm";

const turndownService = new TurndownService({
  headingStyle: "atx",
  bulletListMarker: "-",
  codeBlockStyle: "fenced",
  emDelimiter: "*",
});
turndownService.use(gfm);

const SectionContentExpandedView = ({
  section,
  sectionContent,
  onClose,
  onSave,
  folderId,
  onRefreshAnalyze,
}) => {
  const processedContent =
    typeof sectionContent === "string"
      ? sectionContent
      : JSON.stringify(sectionContent, null, 2);

  const [editedContent, setEditedContent] = useState(processedContent || "");
  const [originalContent, setOriginalContent] = useState(processedContent || "");
  const [hasContentChanged, setHasContentChanged] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const contentRef = useRef(null);

  // Force remount of contentEditable div to prevent React removeChild crash
  const [prevResponse, setPrevResponse] = useState(processedContent);
  const [renderKey, setRenderKey] = useState(0);

  if (processedContent !== prevResponse) {
    setPrevResponse(processedContent);
    setRenderKey(renderKey + 1);
    setEditedContent(processedContent || "");
    setOriginalContent(processedContent || "");
    setHasContentChanged(false);
  }

  // Handle the save button text display timeout
  useEffect(() => {
    if (saveSuccess) {
      const timer = setTimeout(() => {
        setSaveSuccess(false);
        if (onSave) onSave();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [saveSuccess, onSave]);

  const handleContentChange = (e) => {
    // Convert edited HTML back to markdown so tables/lists/headings survive the round-trip.
    const newContent = turndownService.turndown(e.currentTarget.innerHTML);
    setEditedContent(newContent);
    setHasContentChanged(newContent !== originalContent);
  };

  const handleSaveContent = async () => {
    if (!hasContentChanged) return;

    setIsSaving(true);
    setSaveSuccess(false);

    try {
      const token = await getFreshAccessToken();

      const response = await api.patch(
        `api/v1/rfp/folders/${folderId}/analysis/edit/`,
        {
          section_id: section.id.toString(),
          section_response: editedContent,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        setOriginalContent(editedContent);
        setHasContentChanged(false);

        // Fetch fresh data before closing edit mode
        if (onRefreshAnalyze) {
          await onRefreshAnalyze();
        }

        setIsSaving(false);
        setSaveSuccess(true);
      } else {
        throw new Error(`Failed to save: ${response.status}`);
      }
    } catch (error) {
      console.error("Save error:", error);
      setIsSaving(false);

      let errorMessage = "Failed to save changes";
      if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      toast.error(errorMessage);
    }
  };

  const getSaveButtonText = () => {
    if (isSaving) return "Saving...";
    if (saveSuccess) return "Saved";
    return "Save";
  };

  return (
    <div className="bg-white border border-[#BB42AE] rounded-[8px] shadow-sm overflow-hidden flex flex-col">
      {/* Editable Response Content */}
     <div className="p-3 h-fit overflow-y-auto max-h-[calc(100vh-500px)] custom-scrollbar">
        {processedContent ? (
          <div
            key={`editable-${renderKey}`}
            ref={contentRef}
            contentEditable={true}
            suppressContentEditableWarning={true}
            onInput={handleContentChange}
            className="prose prose-sm max-w-none text-[#18101C] font-outfit leading-relaxed outline-none focus:outline-none text-[14px]"
          >
            <MemoizedMarkdown content={processedContent} />
          </div>
        ) : (
          <div
            key={`empty-${renderKey}`}
            ref={contentRef}
            contentEditable={true}
            suppressContentEditableWarning={true}
            onInput={handleContentChange}
            className="text-gray-400 italic font-outfit text-[14px] outline-none focus:outline-none min-h-[100px] flex items-center justify-center"
          >
            No content generated yet.
          </div>
        )}
      </div>

      {/* Action Buttons */}
      <div className="px-4 py-3 border-t border-gray-100 flex items-center justify-end gap-3 bg-white">
        <button
          onClick={onClose}
          className="px-6 py-1.5 rounded-md bg-white border border-[#BB42AE] text-[#BB42AE] text-[14px] font-outfit font-medium hover:bg-[#FFECFD] transition-colors"
        >
          Cancel
        </button>

        <button
          onClick={handleSaveContent}
          disabled={!hasContentChanged || isSaving}
          className={`px-6 py-1.5 rounded-md text-[14px] font-outfit font-medium transition-colors ${
            saveSuccess
              ? "bg-[#BB42AE] text-white"
              : !hasContentChanged || isSaving
              ? "bg-[#BB42AE] text-white opacity-60 cursor-not-allowed"
              : "bg-[#BB42AE] text-white hover:opacity-90"
          }`}
        >
          {getSaveButtonText()}
        </button>
      </div>
    </div>
  );
};

export default SectionContentExpandedView;